import { createSlice } from "@reduxjs/toolkit";

const cartSlice = createSlice({
  name: "cart",
  initialState: {
    cart: localStorage.getItem("cart")
      ? JSON.parse(localStorage.getItem("cart"))
      : [],
    loading: false,
    error: false,
  },
  reducers: {
    addToCart: (state, action) => {
      const product = action.payload;
      const existingProductIndex = state?.cart?.findIndex(
        (item) => item._id === product._id
      );

      if (existingProductIndex !== -1) {
        state.cart[existingProductIndex].quantity += product.quantity;
      } else {
        state.cart.push(product);
      }

      localStorage.setItem("cart", JSON.stringify(state.cart));
    },
    increaseQuantity: (state, action) => {
      const productId = action.payload;
      const existingProduct = state.cart.find((item) => item._id === productId);

      if (existingProduct) {
        existingProduct.quantity += 1;
        localStorage.setItem("cart", JSON.stringify(state.cart));
      }
    },
    decreaseQuantity: (state, action) => {
      const productId = action.payload;
      const existingProduct = state.cart.find((item) => item._id === productId);

      if (existingProduct && existingProduct.quantity > 1) {
        existingProduct.quantity -= 1;
        localStorage.setItem("cart", JSON.stringify(state.cart));
      }
    },
    removeFromCart: (state, action) => {
      const productId = action.payload;
      state.cart = state.cart.filter((item) => item._id !== productId);
      localStorage.setItem("cart", JSON.stringify(state.cart));
    },
    clearCart: (state) => {
      state.cart = [];
      localStorage.removeItem("cart");
    },
  },
});

export const {
  addToCart,
  clearCart,
  increaseQuantity,
  decreaseQuantity,
  removeFromCart,
} = cartSlice.actions;
export default cartSlice.reducer;
